import React from 'react';
import { Spinner, Modal } from 'react-bootstrap';

function LoadingSpinner({ show, spinnerColor }) {
    const spinnerStyle = {
        color: spinnerColor,
      };
  return (
    <Modal show={show} centered>
      <Modal.Body className="text-center">
        <Spinner animation="border" role="status" style={spinnerStyle} >
          <span className="visually-hidden">Loading...</span>
        </Spinner>
        <p className="mt-2">Loading...  Creating Your Account...</p>
      </Modal.Body>
    </Modal>
  );
}

export default LoadingSpinner;
